import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { DataGrid, GridColDef } from '@mui/x-data-grid';

const ManageStorageIntegrations = () => {
  const [integrations, setIntegrations] = useState([]);

  useEffect(() => {
    const fetchIntegrations = async () => {
      try {
        const response = await axios.get('/snowflake/integrations');
        setIntegrations(response.data);
      } catch (error) {
        console.error('Error fetching integrations:', error);
      }
    };

    fetchIntegrations();
  }, []);

  const columns = [
    {
      field: 'name',
      headerName: 'Name',
      width: 200,
      renderCell: (params) => (
        <Link to={`/console/storage-integrations/${params.value}`} style={{ textDecoration: 'none', color: 'inherit' }}>
          {params.value}
        </Link>
      ),
    },
    { field: 'type', headerName: 'Type', width: 200 },
    { field: 'category', headerName: 'Category', width: 200 },
    { field: 'enabled', headerName: 'Enabled', width: 200 },
    { field: 'comment', headerName: 'Comment', width: 300 },
    { field: 'created_on', headerName: 'Created On', width: 200 },
  ];

  return (
    <Box m="20px">
      <Typography variant="h4">Manage Storage Integrations</Typography>
      <div style={{ height: 1000, width: '100%' }}>
      <DataGrid
        rows={integrations}
        columns={columns}
        pageSize={75}
        rowsPerPageOptions={[5]}
        checkboxSelection={false}
        getRowId={(row) => row.name}
      />
      </div>
    </Box>
  );
};

export default ManageStorageIntegrations;